import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext();

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider');
  }
  return context;
};

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  const setBreadcrumb = useCallback((items) => {
    setBreadcrumbItems(items);
  }, []);

  const clearBreadcrumb = useCallback(() => {
    setBreadcrumbItems([]);
  }, []);

  const addBreadcrumbItem = useCallback((item) => {
    setBreadcrumbItems(prev => [...prev, item]);
  }, []);

  const updateBreadcrumbItem = useCallback((index, item) => {
    setBreadcrumbItems(prev => {
      const newItems = [...prev];
      newItems[index] = { ...newItems[index], ...item };
      return newItems;
    });
  }, []);

  const value = {
    breadcrumbItems,
    setBreadcrumb,
    clearBreadcrumb,
    addBreadcrumbItem,
    updateBreadcrumbItem
  };

  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
};